import React from 'react';
import { TopbarContainer } from '../../containers';
import { bool } from 'prop-types';
import { propTypes } from '../../util/types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Page,
} from '../../components';
import { ContactForm } from '../../forms';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import flowchart1 from './flowchart1.png';
import flowchart2 from './flowchart2.png';
import css from './ContactPage.module.css';

export const ContactPageComponent = props => {
  const { currentUser = null, scrollingDisabled, intl } = props;
  const user = ensureCurrentUser(currentUser);

  const userFirstName = user.attributes.profile.firstName;
  const userLastName = user.attributes.profile.lastName;
  const userId = user && user.id && user.id.uuid;
  const userEmail = user.attributes.email;
  const initialValues = {
    name: `${userFirstName} ${userLastName}`,
    email: userEmail,
  };
  const title = intl.formatMessage({ id: 'ContactPage.title' });

  return (
    <Page
      title={title}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactPage',
        name: title,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Contact us</h1>
          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p>
                Signalise is a multi-stakeholder co-operative of Deaf people and communication
                professionals.
              </p>
              <p>
                We've come together to create a community business run by the experts in delivering
                services: the users and providers. <br />
                That's us.
              </p>
            </div>
            <div className={css.contentMain}>
              <section>
                <div className={css.contactContent}>
                  <div>
                    <h2 className={css.contactContentSections}>Our Email Details</h2>
                    <h3>General Enquiries</h3>
                    <a href="mailto:hello@signalise.coop">hello@signalise.coop</a>
                    <h3>Bookings Enquiries</h3>
                    <a href="mailto:bookings@signalise.coop">bookings@signalise.coop</a>
                    <h3>Finance Enquiries</h3>
                    <a href="mailto:finance@signalise.coop">finance@signalise.coop</a>
                    <h3>Feedback</h3>
                    <a href="mailto:feedback@signalise.coop">feedback@signalise.coop</a>
                  </div>
                  <div>
                    <h2 className={css.contactContentSections}>Our Phone Numbers</h2>
                    <p>
                      <span className={css.contactNumbers}>
                        <span>Telephone:</span> <a href="tel:01518080373">0151 808 0373</a>
                      </span>
                      <span className={css.contactNumbers}>
                        <span>SMS/WhatsApp:</span> <a href="tel:07723469028">07723 469 028</a>
                      </span>
                    </p>
                    <h2 className={css.contactContentSections}>Our Office Address</h2>
                    <p>
                      54 St James Street
                      <br />
                      Liverpool
                      <br />
                      L1 0AB
                      <br />
                    </p>
                  </div>
                </div>
              </section>

              <section className={css.contactForm}>
                <h2>Contact Form</h2>

                <ContactForm
                  userFirstName={userFirstName}
                  userLastName={userLastName}
                  userEmail={userEmail}
                  submitted={props.location.search === '?success=ok'}
                ></ContactForm>
              </section>
              <section className={css.container}>
                <img src={flowchart1} alt="Complaint flowchart 1" className={css.flowchart} />
              </section>
              <section className={css.container}>
                <img src={flowchart2} alt="Complaint flowchart 2" className={css.flowchart} />
              </section>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

ContactPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const ContactPage = compose(connect(mapStateToProps), injectIntl)(ContactPageComponent);

export default ContactPage;
